const namespaced = true

const state = {}

const actions = {
    async getAllAbstracts({ dispatch }) {
        return await dispatch('database/getItems', { table: 'abstracts' }, { root: true })
    },
    async getAllAbstractsAllocated({ dispatch }) {
       let data = await dispatch('database/getMultiple', ['abstracts', 'sessions', 'session_presentation_links', 'presentation_abstract_links'], { root: true });
        let abstractsToReturn = [];
        let presentationLinks = data['session_presentation_links'];
        let abstracts = data['abstracts'];
        let abstractLinks = data['presentation_abstract_links'];
        let sessions = data['sessions'];

        for (let a = 0; a < abstractLinks.length; a++) {
            let absLink = abstractLinks[a];

            let abs = abstracts.find(a => a.id == absLink.abstract_id)
            let presLinks = presentationLinks.filter(pl => pl.presentation_id == absLink.presentation_id)
            for (let b = 0; b < presLinks.length; b++) {

                try {
                    let presLink = presLinks[b];
                    presLink.abs_id = abs.id;
                    presLink.final_sort = abs.final_sort;
                    presLink.workshop_final_sort = abs.workshop_final_sort;
                    presLink.title = abs.title;
                    presLink.authors = abs.authors;
                    presLink.absText = abs.text;

                    let session = sessions.find(s => s.id == presLink.session_id)
                    if (session) {
                        abstractsToReturn.push(abs)
                    }
                } catch (err) {
                    console.log('no abs', absLink)
                }

            }
        }
        console.log('abs', abstractsToReturn)
        return abstractsToReturn

    },


    async getAbstract({ dispatch }, id) {
        let abstract = null
        try {
            abstract = await dispatch('database/getItem', { table: 'abstracts', id: id }, { root: true })
        } catch (err) {
            console.log('no abstract')
        }
        return abstract;
    },
    async getAllAbstractsByType({ dispatch }, type) {
        let abstracts = await dispatch('database/getItems', { table: 'abstracts' }, { root: true });


        for (let i = 0; i < abstracts.length; i++) {
            if (abstracts[i].selection_result) { //if selection
                let selection = abstracts[i].selection_result;
                if (selection.includes("+" || selection.includes("-"))) { //IF PROGRAMME + WORKSHOP
                    abstracts[i].programmeType = selection.split('+')[0];
                    abstracts[i].workshopTopic = selection.substring(
                        selection.indexOf("+") + 3,
                        selection.lastIndexOf("-")
                    );
                    abstracts[i].workshopType = selection.split('-')[1];


                } else { //IF "NORMAL"
                    abstracts[i].programmeType = selection;
                }


            }

            //THERE ARE SOME EXCEPTIONS / INCONSISTENCIES SO I TRY TO FIX THEM HERE
            if (abstracts[i].programmeType && abstracts[i].programmeType.toLowerCase() == 'reserve oral') { //Reserve Orals have to be catalogued as Posters!!! crazyy!!
                abstracts[i].programmeType = 'Poster'
            }
            if (abstracts[i].workshopType && abstracts[i].workshopType.toLowerCase() == 'reserve oral') { //Reserve Orals have to be catalogued as Posters!!! crazyy!!
                abstracts[i].workshopType = 'Poster'
            }
            if (abstracts[i].programmeType && abstracts[i].programmeType.toLowerCase() == 'flash') { //flash equals oral
                abstracts[i].programmeType = 'Oral'
            }
            if (abstracts[i].workshopType && abstracts[i].workshopType.toLowerCase() == 'flash') { //flash equals oral
                abstracts[i].workshopType = 'Oral'
            }
            if (abstracts[i].programmeType == 0 || abstracts[i].programmeType == '0') {  //there is a couple of abstracts that were sent late with WStopic and type, but not "programme" type.
                abstracts[i].programmeType = null;
            }
            if (abstracts[i].programmeType && abstracts[i].programmeType.toLowerCase() == 'oral/poster') { //oral/poster are supposed to be both
                abstracts[i].programmeType = 'Oral/Poster' //i compare with include() in the abstract view. I know this doesnt do anything but I will leave it here in case we have to change anything, because I will forget.
            }
        }
        let abstractsToReturn = abstracts

        // console.log(abstractsToReturn)

        return abstractsToReturn
    },
    async getPresentationForAbstract({ dispatch }, id) {
        let sessions = [];
        let presentation = {};
        let data = await dispatch('database/getMultiple', ['person_roles', 'sessions', 'sessiontypes', 'session_sessiontype_links', 'locations', 'session_location_links', 'presentations', 'session_presentation_links', 'persons', 'presentation_abstract_links'], { root: true });
        let pal = data['presentation_abstract_links'].find(link => link.abstract_id == id);
        console.log('PAL', pal)
        let preslink = data['session_presentation_links'].find(spl => spl.presentation_id == pal.presentation_id);
        console.log('PAL', preslink)

        let session = data['sessions'].find(sess => sess.id == preslink.session_id);
        preslink.color = session.color;
        preslink.session = session;
        preslink.sess_id = session.id;
        let presentationsTmp = data['presentations'].find(presentation => presentation.id == preslink.presentation_id);
        if (presentationsTmp) {
            preslink.pres_id = presentationsTmp.id;
            preslink.title = presentationsTmp.title;
        }
        console.log('PAL', preslink)
        return preslink;
    },


    async getPresentationsForAbstract({ dispatch }, id) {
        let sessions = [];
        let presentation = {};

        let listToReturn = [];
        let data = await dispatch('database/getMultiple', ['sessions', 'sessiontypes', 'session_sessiontype_links', 'locations', 'session_location_links', 'presentations', 'session_presentation_links', 'presentation_abstract_links'], { root: true });
        let pal = data['presentation_abstract_links'].find(link => link.abstract_id == id);
        console.log('PAL', pal)
        let preslink = data['session_presentation_links'].filter(spl => spl.presentation_id == pal.presentation_id);
        console.log('PAL', preslink)

        for (let i = 0; i < preslink.length; i++) {
            let link = preslink[i];

            let session = data['sessions'].find(sess => sess.id == link.session_id);
            link.color = session.color;
            link.session = session;
            link.sess_id = session.id;
            let presentationsTmp = data['presentations'].find(presentation => presentation.id == link.presentation_id);
            if (presentationsTmp) {
                link.pres_id = presentationsTmp.id;
                link.title = presentationsTmp.title;
            }
            console.log('PAL', preslink)
            listToReturn.push(link)
        }

        return listToReturn;
    },


    async getAllPresentationsWithAbstracts({ dispatch }, part) {
        let data = await dispatch('database/getMultiple', ['presentations', 'session_presentation_links', 'abstracts', 'presentation_abstract_links', 'sessions', 'sessiontypes', 'session_sessiontype_links'], { root: true });
        let presentationsToReturn = [];
        let presentationLinks = data['session_presentation_links'];
        let abstracts = data['abstracts'];
        let abstractLinks = data['presentation_abstract_links'];
        let sessions = data['sessions'];
        let sessiontypes = data['sessiontypes'];
        let sessionTypeLinks = data['session_sessiontype_links'];
        let presentations = data['presentations'];

        for (let a = 0; a < abstractLinks.length; a++) {
            let absLink = abstractLinks[a];

            let abs = abstracts.find(a => a.id == absLink.abstract_id)
            let presLinks = presentationLinks.filter(pl => pl.presentation_id == absLink.presentation_id)
            for (let b = 0; b < presLinks.length; b++) {

                try {
                    let presLink = presLinks[b];
                    presLink.abs_id = abs.id;
                    presLink.final_sort = abs.final_sort;
                    presLink.workshop_final_sort = abs.workshop_final_sort;
                    presLink.title = abs.title;
                    presLink.authors = abs.authors;
                    presLink.absText = abs.text;

                    let session = sessions.find(s => s.id == presLink.session_id)
                    if (session) {
                        presLink.topic = session.topic;
                        presLink.type = session.session_type;
                        presLink.workshop_topic = session.workshop_topic
                        /*let typeLink = sessionTypeLinks.find(stl => stl.session_id == session.id)
                        if (typeLink) {
                            let type = sessiontypes.find(st => st.id == typeLink.sessiontype_id);
                            presLink.type = type.name;
                        }*/
                        presentationsToReturn.push(presLink)
                    }
                } catch (err) {
                    console.log('no abs', absLink)
                }

            }
        }
        console.log('abs', presentationsToReturn)
        return presentationsToReturn


    },

    async getAllPresentationsWithAbstractsFromProgramme({ dispatch }, part) {
        let data = await dispatch('database/getMultiple', ['presentations', 'session_presentation_links', 'abstracts', 'presentation_abstract_links', 'sessions', 'sessiontypes', 'session_sessiontype_links', 'tags', 'session_tag_links'], { root: true });
        let presentationsToReturn = [];
        let presentationLinks = data['session_presentation_links'];
        let abstracts = data['abstracts'];
        let abstractLinks = data['presentation_abstract_links'];
        let sessions = data['sessions'];
        let sessiontypes = data['sessiontypes'];
        let sessionTypeLinks = data['session_sessiontype_links'];
        let tags = data['tags'];
        let sessionTagLinks = data['session_tag_links'];
        let presentations = data['presentations'];

        for (let a = 0; a < abstractLinks.length; a++) {
            let absLink = abstractLinks[a];

            let abs = abstracts.find(a => a.id == absLink.abstract_id)
            let presLinks = presentationLinks.filter(pl => pl.presentation_id == absLink.presentation_id)
            for (let b = 0; b < presLinks.length; b++) {

                try {
                    let presLink = presLinks[b];
                    presLink.abs_id = abs.id;
                    presLink.final_sort = abs.final_sort;
                    presLink.title = abs.title;
                    presLink.authors = abs.authors;
                    presLink.absText = abs.text;

                    let session = sessions.find(s => s.id == presLink.session_id)
                    if (session) {
                        // presLink.topic = session.topic;
                        // presLink.type = session.session_type;
                        
                        let typeLink = sessionTypeLinks.find(stl => stl.session_id == session.id)
                        if (typeLink) {
                            let type = sessiontypes.find(st => st.id == typeLink.sessiontype_id);
                            presLink.type = type.name;
                        }
                        let topicLink = sessionTagLinks.find(stl => stl.session_id == session.id)
                        if (topicLink) {
                            let topic = tags.find(st => st.id == topicLink.tag_id);
                            presLink.topic = topic.title;
                        }
                        presentationsToReturn.push(presLink)
                    }
                } catch (err) {
                    console.log('no abs', absLink)
                }

            }
        }
        // console.log('abs', presentationsToReturn)
        return presentationsToReturn


    },


}
const mutations = {}
const getters = {}

export const abstracts = {
    namespaced,
    state,
    getters,
    mutations,
    actions
}
